import { Component } from '@angular/core';
import {Helper} from '../../classes/helpers';

@Component({
  selector: 'app-stepper',
  templateUrl: Helper.getPortalTemplate(),
  styleUrls: [Helper.getPortalStyle()],
})
export class StepperComponent {
  constructor() {}

}
